import type { Response, PageQueryParams, CollectionResponse } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface Article {
  id: number
  title: string
  slug: string
  content: string
  type: string
  status: string
  created_at: string
  updated_at: string
}

export interface ArticleSearchParams extends PageQueryParams {
  search?: string
  type?: string
  status?: string
}

export interface ArticleFormParams {
  title: string
  content?: string
  type?: string
  status?: string
}

export const articleService = {
  list(params: ArticleSearchParams) {
    return HttpRequest.get("v1/articles", {
      searchParams: params as any,
    }).json<CollectionResponse<Article>>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/articles/${id}`).json<Response<Article>>()
  },

  create(params: ArticleFormParams) {
    return HttpRequest.post("v1/articles", {
      json: params,
    }).json<Response<Article>>()
  },

  update(id: number, params: ArticleFormParams) {
    return HttpRequest.put(`v1/articles/${id}`, {
      json: params,
    }).json<Response<Article>>()
  },

  delete(id: number) {
    return HttpRequest.delete(`v1/articles/${id}`).json<Response>()
  },
}
